import * as React from "react";
import { Route, Redirect, withRouter, match, Switch } from "react-router";
import { BitacoraRADList } from "./list/list";
import { BitacoraRADEdit } from "./edit/edit";
import { BitacoraStatusRADList } from "./status";
import { ReporteEficienciaRAD } from "./reporte";

export class BitacoraRAD extends React.Component<{ match: match<{}> }> {
    render() {
        const path = this.props.match.path;
        return (
            <div>
                <Switch>
                    <Route exact path={path} component={BitacoraRADList} />
                    <Route exact path={path + "/reporte"} component={ReporteEficienciaRAD} />
                    <Route exact path={path + "/status/:id"} component={BitacoraStatusRADList} />
                    <Route exact path={path + "/:id"} component={BitacoraRADEdit} />
                </Switch>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/index.tsx